import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import List from '../../../shared/components/List';
import Section from '../../../shared/components/Section';
import Separator from '../../../shared/structure/Separator';
import SubscribeShareSection from '../../../shared/components/SubscribeShareSection';
import Paragraph from '../../../shared/components/Paragraph';
import VoiceLink from '../../../shared/components/Link';
import { constitutionUrl } from '../../../../globals';
import Quote from '../../../shared/components/Quote';

export default function InfoContainer() {
  const { t } = useTranslation();

  return (
    <>
      <Section
        background="blue"
        title={t('info_heading')}
      />
      <Section
        content={(
          <>
            <Paragraph
              bold
              color="textSecondary"
              variant="body2"
            >
              {t('info_sub_heading')}
            </Paragraph>
            <Separator />
            <Paragraph>
              {t('info_p_1')}
            </Paragraph>
            <Paragraph>
              {t('info_p_2')}
            </Paragraph>
            <Paragraph
              title={t('info_h_1')}
            >
              {t('info_h1_p_1')}
            </Paragraph>
            <Paragraph>
              {t('info_h1_p_2')}
            </Paragraph>
            <Quote>
              <Trans
                i18nKey="info_h1_p_3"
                components={{ bold: <strong />, italic: <i /> }}
              />
            </Quote>
            <Paragraph
              title={t('info_h_2')}
            >
              <VoiceLink
                color="primary"
                href={constitutionUrl}
              >
                {t('info_h2_link')}
              </VoiceLink>
              {t('info_h2_p_1')}
            </Paragraph>
            <Paragraph>
              {t('info_h2_p_2')}
            </Paragraph>
            <List numbered>
              <li>
                <Trans
                  i18nKey="info_h2_list_item_1"
                  components={{ bold: <strong /> }}
                />
              </li>
              <li>
                <Trans
                  i18nKey="info_h2_list_item_2"
                  components={{ bold: <strong /> }}
                />
              </li>
            </List>
            <Paragraph>
              {t('info_h2_p_3')}
            </Paragraph>
            <Paragraph
              title={t('info_h_3')}
            >
              {t('info_h3_p_1')}
            </Paragraph>
            <Paragraph>
              <Trans
                i18nKey="info_h3_p_2_start"
                components={{ bold: <strong /> }}
              />
              <VoiceLink
                color="primary"
                href={constitutionUrl}
              >
                {t('info_h3_p_2_link')}
              </VoiceLink>
              <Trans
                i18nKey="info_h3_p_2_end"
                components={{ bold: <strong /> }}
              />
            </Paragraph>
            <Paragraph>
              <Trans
                i18nKey="info_h3_p_3_start"
                components={{ bold: <strong /> }}
              />
              <VoiceLink
                color="primary"
                href="http://bit.ly/golos-final-report"
              >
                {t('info_h3_p_3_link')}
              </VoiceLink>
              <Trans
                i18nKey="info_h3_p_3_end"
                components={{ bold: <strong /> }}
              />
            </Paragraph>
            <Paragraph>
              {t('info_h3_p_4')}
            </Paragraph>
            <Paragraph
              title={t('info_h_4')}
            >
              {t('info_h4_p_1')}
            </Paragraph>
            <Paragraph>
              <Trans
                i18nKey="info_h4_p_2"
                components={{ bold: <strong /> }}
              />
            </Paragraph>
            <Paragraph>
              <Trans
                i18nKey="info_h4_p_3"
                components={{ bold: <strong /> }}
              />
            </Paragraph>
            <Paragraph>
              <Trans
                i18nKey="info_h4_p_4"
                components={{ bold: <strong /> }}
              />
            </Paragraph>
            <Paragraph>
              {t('info_h4_p_5')}
            </Paragraph>
            <Paragraph
              title={t('info_h_5')}
            >
              {t('info_h5_p_1')}
            </Paragraph>
            <Paragraph>
              {t('info_h5_p_2')}
            </Paragraph>
            <Paragraph>
              {t('info_h5_p_3')}
            </Paragraph>
            <List>
              <li>
                {t('info_h5_list_item_1')}
              </li>
              <li>
                {t('info_h5_list_item_2')}
              </li>
              <li>
                {t('info_h5_list_item_3')}
              </li>
              <li>
                {t('info_h5_list_item_4')}
              </li>
            </List>
            <Paragraph>
              {t('info_h5_p_4')}
            </Paragraph>
            <Paragraph
              title={t('info_h_6')}
            >
              {t('info_h6_p_1')}
              <VoiceLink
                color="primary"
                href={constitutionUrl}
              >
                {t('info_h6_link')}
              </VoiceLink>
            </Paragraph>
            <Paragraph
              title={t('info_h_7')}
            >
              {t('info_h7_p_1')}
            </Paragraph>

            <SubscribeShareSection shareUrl="https://golos2020.org/constitution" />

            <Separator />

            <Paragraph
              bold
              color="textSecondary"
              variant="body2"
            >
              {t('info_sub_heading_bottom')}
              <VoiceLink
                big
                color="primary"
                href={constitutionUrl}
              >
                {t('info_h6_link')}
              </VoiceLink>
            </Paragraph>
          </>
        )}
      />
    </>
  );
}
